// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const CloudInventoryAccountStatusSchema = z.enum(['ACTIVE','SYNC_ERROR','DISCONNECTED'] as const);

export type CloudInventoryAccountStatusType = `${z.infer<typeof CloudInventoryAccountStatusSchema>}`

export default CloudInventoryAccountStatusSchema;
